<div class="row row-cols-1 row-cols-lg-2 pb-5 align-items-start">
  @if (currentStep > 1) {
    <div
      class="col col-lg-6 p-2 p-lg-3 rounded border border-primary text-body border-3 mb-3 mb-lg-0"
      [class.mobile-brief-section]="!largeView"
    >
      <div class="d-flex flex-column flex-lg-row gap-2">
        <div class="w-100 flex-lg-fill order-2 order-lg-1">
          <div class="d-flex flex-wrap flex-lg-column gap-3">
            <div
              (click)="currentStep = 1; editField('runSheetInputField')"
              role="button"
            >
              <dt>Patrol Run</dt>
              <dd>{{ runSheetName }}</dd>
            </div>
            @if (currentStep > 2) {
              <div
                (click)="currentStep = 2; formatScheduleForm()"
                role="button"
              >
                <dt>Schedule</dt>
                <dd>
                  {{ schedulerForm.value | misc: "shiftSummary" : true }}
                  @if (schedulerForm.value | misc: "getTimeDifference") {
                    [Duration:
                    {{ schedulerForm.value | misc: "getTimeDifference" }} Hrs]
                  }
                </dd>
              </div>
            }
            @if (checkListData?.length) {
              <div (click)="onPatrolSummaryClick()" role="button">
                <dt>Patrol List [{{ checkListData?.length }}]</dt>
                <dd>
                  <ol class="ps-4">
                    @for (checklist of checkListData; track $index) {
                      <li
                        class="my-3 patrol-list-entry"
                        [attr.role]="currentStep == 3 ? 'button' : ''"
                        (click)="
                          scrollToChecklist($index);
                          $event.stopImmediatePropagation()
                        "
                      >
                        {{ checklist?.site?.company_name || "Other Tasks" }}
                        <span class="view-button"></span>
                        <!-- <i class="fa-solid fa-caret-right"></i> -->
                      </li>
                    }
                  </ol>
                </dd>
              </div>
            }
          </div>
        </div>
        @if (
          runSheetSuggestionsDataList?.length && [2, 3].includes(currentStep)
        ) {
          <div class="w-100 flex-lg-fill order-1 order-lg-2">
            <div class="fw-semibold small mb-2 d-flex gap-2">
              Preload Sites & Tasks
            </div>
            <div class="d-flex flex-wrap gap-1">
              @for (
                runsheet of runSheetSuggestionsDataList?.slice(0, 4);
                track runsheet
              ) {
                <div (click)="selectSuggestedRunsheet(runsheet)">
                  <div
                    class="bg-secondary-subtle p-2 border rounded small-font text-dark h-100 d-flex align-items-center"
                    role="button"
                  >
                    <div class="d-flex gap-2">
                      <div class="flex-grow-1 fw-semibold">
                        {{ runsheet?.name }}
                      </div>
                      <div>
                        <i class="fa-solid fa-list-check"></i>
                        {{ runsheet?.task_count }}
                      </div>
                    </div>
                  </div>
                </div>
              }
              @if (runSheetSuggestionsDataList?.length > 4) {
                <div>
                  <select
                    class="form-select"
                    id="runSheetSuggestions"
                    (change)="onSelectRunsheet($event)"
                  >
                    <option value="" disabled selected>Select</option>
                    @for (
                      runsheet of runSheetSuggestionsDataList?.slice(
                        4,
                        showSuggestionNum
                      );
                      track runsheet
                    ) {
                      <option [value]="runsheet?.id">
                        {{ runsheet?.name }}
                      </option>
                    }
                  </select>
                </div>
              }
            </div>
          </div>
        }
      </div>
    </div>
  }

  <div class="col px-lg-2">
    @if (currentStep === 1) {
      <div class="input-group mb-2">
        <div class="form-floating">
          <input
            class="form-control"
            autocomplete="off"
            id="runSheetInputField"
            type="text"
            [(ngModel)]="runSheetName"
            placeholder="Patrol Run Name"
            maxlength="100"
          />
          <label>Patrol Run Name</label>
        </div>
        @if (runSheetName) {
          <span
            class="input-group-text"
            (click)="editField('runSheetInputField')"
          >
            <i class="fa-solid fa-xmark"></i>
          </span>
        }
      </div>
      <div class="d-flex gap-2 mb-4">
        <button
          type="button"
          class="btn btn-lg btn-secondary w-100"
          (click)="goBack()"
        >
          Cancel
        </button>

        <button
          type="button"
          class="btn btn-lg btn-primary w-100"
          [disabled]="!runSheetName"
          (click)="currentStep = 2; formatScheduleForm()"
        >
          Next
        </button>
      </div>
    }
    <!-- Step 2: Schedule -->
    @if (currentStep === 2) {
      <div class="row row-cols-2 mb-5 mb-lg-4">
        <div class="col">
          <button
            type="button"
            class="btn btn-lg btn-dark w-100"
            (click)="currentStep = 1"
          >
            Back
          </button>
        </div>
        <div class="col">
          <button
            type="button"
            class="btn btn-lg btn-primary w-100"
            [disabled]="!schedulerForm.valid"
            (click)="
              currentStep = 3; getEventDates(); formatTaskStep('forward')
            "
          >
            Next
          </button>
        </div>
      </div>
      @if (scheduleStepperActive) {
        <gtapp-scheduler
          shownFrom="runsheet"
          [dialogBox]="false"
          [schedulerForm]="schedulerForm"
          [editSchedule]="true"
        ></gtapp-scheduler>
      }
    }

    <!-- Step 3: Check List info -->
    @if (currentStep === 3) {
      <div class="row row-cols-2 mb-2">
        <div class="col">
          <button
            type="button"
            class="btn btn-lg btn-dark w-100"
            (click)="currentStep = 2; formatTaskStep('back')"
          >
            Back
          </button>
        </div>
        <div class="col">
          <button
            type="button"
            class="btn btn-lg btn-primary w-100"
            [disabled]="
              !(
                checkListData[checkListData?.length - 1]?.enable_reporting ||
                checkListData[checkListData?.length - 1]?.tasks?.[0]?.note
              )
            "
            (click)="
              currentStep = 4;
              shiftFocus('assigneeId');
              getAssignees();
              formatRunSheetTasks()
            "
          >
            Next
          </button>
        </div>
      </div>

      <gtapp-add-checklist
        [checkListData]="checkListData"
        [schedulerForm]="schedulerForm"
        [scheduleDatesDict]="scheduleDatesDict"
        [dynamicHeight]="largeView ? 65 : 50"
      ></gtapp-add-checklist>

      <!-- <div class="row row-cols-2 mb-2 pb-4">
        <div class="col">
          <button
            type="button"
            class="btn btn-lg btn-dark w-100"
            (click)="currentStep = 2; formatTaskStep('back')"
          >
            Back
          </button>
        </div>
        <div class="col">
          <button
            type="button"
            class="btn btn-lg btn-primary w-100"
            [disabled]="
              !(
                checkListData[checkListData?.length - 1]?.enable_reporting ||
                checkListData[checkListData?.length - 1]?.tasks?.[0]?.note
              )
            "
            (click)="
              currentStep = 4;
              shiftFocus('assigneeId');
              getAssignees();
              formatRunSheetTasks()
            "
          >
            Next
          </button>
        </div>
      </div> -->
    }

    <!-- Step 4: Assign to Guard -->
    @if (currentStep === 4) {
      <div class="row row-cols-2 mb-4">
        <div class="col">
          <button
            type="button"
            class="btn btn-lg btn-dark w-100"
            (click)="currentStep = 3; assigneeList = []"
          >
            Back
          </button>
        </div>
        <div class="col">
          <button
            type="button"
            class="btn btn-primary btn-lg w-100"
            (click)="onAddRunSheet()"
            [disabled]="
              addRunSheetPressed ||
              !schedulerForm.valid ||
              !formattedRunSheetTasks?.length
            "
          >
            Add Scheduled Patrol
          </button>
        </div>
      </div>
      <ng-container>
        @if (assignedGuardData?.id) {
          <div class="d-flex align-items-center">
            <div class="flex-grow-1">
              <dt>Assign To</dt>
              <dd (click)="editField('assignee')" class="link-edit">
                {{ assignedGuardData?.full_name }}
              </dd>
            </div>
            <div class="d-none">
              <span (click)="editField('assignee')">
                <i
                  class="fa-solid fa-pen-to-square md-font-size text-secondary"
                ></i
              ></span>
            </div>
          </div>
        } @else {
          <gtapp-auto-complete
            [data]="assigneeList"
            placeHolder="Assign To"
            searchKeyword="full_name"
            [itemTemplate]="assigneeTemplate"
            (inputChanged)="onAssigneeSearch($event)"
            (selected)="onAssigneeSelect($event)"
            [enableCloseOption]="true"
            (fieldCleared)="editField('assignee')"
            [inputId]="'assigneeId'"
          >
          </gtapp-auto-complete>
          <ng-template #assigneeTemplate let-item>
            <div class="d-flex gap-2 flex-wrap">
              <span>
                {{ item?.full_name }}
              </span>
              @if (item?.access_status === 2) {
                <div
                  class="text-warning-emphasis small-font bg-white rounded my-auto border px-2 fw-semibold"
                >
                  Casual
                </div>
              }
            </div>

            @if (item?.subcontractors?.length) {
              <div class="small text-secondary">
                🟧Subcontractor:
                <span class="subcontractor-name">{{
                  item?.subcontractors
                }}</span>
              </div>
            }
          </ng-template>
        }
        <div></div>
      </ng-container>
    }
  </div>
</div>
